// extracted by css-extract-rspack-plugin
export default {"SavedEntityListRoot":"TX4Wr","SavedEntityListItem":"YEyhb","SavedEntityListItemIcon":"NC5Hf","LoadingWrapper":"EsT6g"};